import React, { useEffect, useState } from "react";
import { FaCopy } from "react-icons/fa";
import { GeneratedResponse } from "./types";
import { IoMdEye } from "react-icons/io";
import { IoMdEyeOff } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { useGeneratedResponsesStore } from "./store";
interface GeneratedResponsesProps {
  generatedResponses: GeneratedResponse[];
  format: string;
  handleCopyResponse: (response: GeneratedResponse) => void;
}

const GeneratedResponses: React.FC<GeneratedResponsesProps> = ({
  generatedResponses,
  format,
  handleCopyResponse,
}) => {
  const removeResponse = useGeneratedResponsesStore(
    (state) => state.removeResponse
  );
  const [showHistory, setShowHistory] = useState(false);
  useEffect(() => {
    if (generatedResponses.length === 1) {
      setShowHistory(false);
      const height = document.body.scrollHeight;
      window.parent.postMessage({ type: "setHeight", height }, "*");
    }
  }, [generatedResponses]);
  const removeFromHis = (id: number) => {
    try {
      console.log("generatedResponses---", generatedResponses);
      const afterRemove: GeneratedResponse[] = generatedResponses.filter(
        (item) => item.id !== id
      );
      removeResponse(afterRemove);
      const height = document.body.scrollHeight;
      window.parent.postMessage({ type: "setHeight", height }, "*");
    } catch (error) {
      console.log("error", error);
    }
  };
  return (
    <div className="border rounded bg-white shadow-sm resultBoxHashtag">
      <h5 className="fw-bold mb-3 text-primary">✨ Generated Outputs</h5>
      {(generatedResponses.length > 0 && !showHistory
        ? [generatedResponses[0]]
        : generatedResponses
      ).map((response, i) => (
        <>
          <div
            key={response.id}
            className={`${
              i === 0 && generatedResponses.length > 1 ? "mb-2" : "mb-2"
            } p-3 bg-light rounded position-relative`}
          >
            <div className="d-flex align-items-center mb-2">
              <h6 className="fw-bold text-muted">
                {response.platform} ({response.writingTone}) -{" "}
                {response.timestamp}
              </h6>
              <FaCopy
                size={20}
                style={{ width: "2rem", marginLeft: "auto" }}
                className="text-primary cursor-pointer "
                onClick={() => handleCopyResponse(response)}
                title="Copy to clipboard"
              />
              {i > 0 && (
                <MdDelete
                  style={{
                    width: "2rem",
                    marginLeft: "0.5rem",
                    cursor: "pointer",
                  }}
                  size={23}
                  className="text-primary cursor-pointer"
                  onClick={() => {
                    response.id && removeFromHis(response.id);
                  }}
                  title="Copy to clipboard"
                />
              )}
            </div>
            <div className="mb-3">
              <h6 className="fw-bold text-muted mb-2">Caption</h6>
              <ol>
                {response.captionList &&
                  response.captionList.map((x, i) => (
                    <li
                      key={i}
                      className="mb-0"
                      style={{
                        fontSize: "1.1rem",
                        fontWeight: "500",
                        color: "#333",
                      }}
                    >
                      {x}
                    </li>
                  ))}
              </ol>
              {/* <p className="mb-0" style={{ fontSize: "1.1rem", fontWeight: "500", color: "#333" }}>
            {response.caption}
          </p> */}
            </div>
            <div>
              <h6 className="fw-bold text-muted mb-2">Hashtags</h6>
              {format === "One line" ? (
                <p
                  className="mb-0 text-primary"
                  style={{ fontSize: "1rem", wordBreak: "break-word" }}
                >
                  {response.hashtags.join(" ")}
                </p>
              ) : (
                <ul className="list-unstyled mb-0">
                  {response.hashtags.map((hashtag: string, index: number) => (
                    <li
                      key={index}
                      className="mb-1 text-primary"
                      style={{ fontSize: "1rem" }}
                    >
                      {`${index + 1}. ${hashtag}`}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          {i === 0 && generatedResponses.length > 1 && (
            <h5
              className="fw-bold mb-2 text-primary"
              style={{ width: "7rem", cursor: "pointer" }}
              onClick={() => {
                setShowHistory(!showHistory);
                const height = document.body.scrollHeight;
                window.parent.postMessage({ type: "setHeight", height }, "*");
              }}
            >
              History <span>{showHistory ? <IoMdEye /> : <IoMdEyeOff />}</span>
            </h5>
          )}
        </>
      ))}
    </div>
  );
};
export default GeneratedResponses;
